<template>
  <button
    class="tw-flex-shrink-0 tw-px-1.5 disabled:tw-opacity-50"
    :class="{'tw-cursor-pointer': isButtonDisabled,
     'searchResult_nextDayItinerary': isArrowNextLink,
     'searchResult_prevDayItinerary' : !isArrowNextLink}"
    :disabled="isButtonDisabled"
    @click="$emit('click')"
  >
    <img
      :src="require('@/assets/icons/arrow-right.svg')"
      :alt="`Arrow ${arrowType}`"
      :class="computedImageClass"
    >
  </button>
</template>

<script>
export default {
  name: "CruiseItineraryNavigationArrow",
  props: {
    isButtonDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    arrowType: {
      type: String,
      required: false,
      default: 'next',
    }
  },
  computed: {
    computedImageClass() {
      return this.arrowType === 'prev' ? 'tw-rotate-180' : '';
    },
    isArrowNextLink() {
      return this.arrowType === 'next'
    },
  },
}
</script>
